import DatasetDateFilterStep1Adapter from 'scoreboard/reports/common/filter/dataset-date-filter-step1-adapter'
import dateFilterStep1InlineTemplate from 'scoreboard/reports/common/filter/date-filter-step1-inline.hbs'
import DateFilterWizard from 'scoreboard/reports/common/filter/date-filter-wizard'

function dateFilterMeta(nameCode) {
	return {
		nameCode,
		filterType: 'date',
		// when adding a new date filter via initiative/scorecard report wizard
		// we show the date filter as part of the
		// report wizard with it's first step inlined
		form: DatasetDateFilterStep1Adapter,
		formOptions: {
			template: dateFilterStep1InlineTemplate
		},
		// when editing an existing date filter, the filter is in it's own wizard
		wizard: DateFilterWizard
	}
}

export default dateFilterMeta

dateFilterMeta.__filename__ = 'reports/common/filter/date-filter-meta.js'
